import React from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";
import { selectSpaceFullScreen } from "slices/spaceSlice";
import ChangeSpaceActive from "../ChangeSpaceActive/ChangeSpaceActive";

const SpaceTitle = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const spaceFullScreen = useSelector(selectSpaceFullScreen);

  return ReactDOM.createPortal(
    <>{spaceBoxActive && !spaceFullScreen && <ChangeSpaceActive />}</>,
    document.getElementById("current-space-info")
  );
};

export default SpaceTitle;
